<template>
  <div v-if="config" class="bottom">
    <div v-if="hasQualify" class="guide-wrapper" @click="$emit('go-next')">
      <div class="guide">{{ config.success_button.content }}</div>
      <div class="ios-padding"></div>
    </div>
    <div v-else-if="config && config.button" class="pay-wrapper">
      <div class="pay-block">
        <div class="remain">
          <div
            class="desc"
            :class="{ 'no-count-down': config.button.close_countdown }"
          >
            {{ config.button.desc || '需要准备一台电脑实操学习' }}
          </div>
          <div v-if="!config.button.close_countdown" class="count-down">
            <CountDown
              class="count-cover"
              :config="countDownConfig"
              @next="handleNext"
              @finish="handleCountDownFinish"
            ></CountDown>
          </div>
          <div
            class="remain-count"
            :class="{ 'no-count-down': config.button.close_countdown }"
          >
            {{ config.button.label }}
          </div>
        </div>
        <component
          :is="targetButton"
          :config="config.button"
          :isAgree="isAgree"
          @click="handlePay"
        ></component>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import CountDown from './CountDown.vue';
import { getCookie, setCookie } from '@/lib/util';
import ButtonV1 from './buttons/ButtonV1.vue';
import ButtonV2 from './buttons/ButtonV2.vue';
const TimeFlag = 'time_record_v3';
let recordTime = 0;
@Component({
  components: {
    CountDown,
    ButtonV1,
  },
})
export default class Bottom extends Vue {
  @Prop({ type: Boolean }) isAgree!: boolean;
  @Prop({ type: Boolean, default: false }) isPaySuccess!: boolean;
  @Prop({
    type: Object,
  })
  config!: any;
  @Prop({ type: Boolean, default: false }) hasQualify!: boolean;
  readonly buttonMap: any = {
    V1: ButtonV1,
    V2: ButtonV2,
  };
  countDownConfig = { time: 0 };
  baseCount = 0;
  remain = 0;
  remainTimeout: any = null;
  targetButton = ButtonV1;
  created() {
    let i: any = this.config;
    if (i && (i = i.button) && (i = i.type) && (i = this.buttonMap[i])) {
      this.targetButton = i;
    }
    // if(config&&config)
  }
  mounted() {
    this.countDownConfig.time = this.config.button.countdown_timestamp;
    this.remain = this.baseCount = this.config.button.remain;

    const time = localStorage.getItem(TimeFlag);
    if (time) {
      const numberTime = Number(time);
      if (numberTime > 0 && numberTime < this.countDownConfig.time) {
        this.countDownConfig = { time: numberTime };
        recordTime = numberTime;
      }
    }
  }
  handleNext(time: number) {
    recordTime = time;
    localStorage.setItem(TimeFlag, String(time));
  }
  handlePay() {
    this.$emit('pay');
  }
  handleCountDownFinish() {
    this.countDownConfig = { time: this.config.button.countdown_timestamp };
  }
  beforeDestroy() {
    clearTimeout(this.remainTimeout);
  }
}
</script>

<style lang="scss" scoped>
$btm-bg-color: #f8a63d;
$main-btn-color: #ea632f;
$main-btn-hover-color: rgba(255, 255, 255, 0.7);
$main-btn-disabled-color: #f4b197;
.bottom {
  background: #fff;
}
.guide-wrapper {
  background-image: linear-gradient(to left, #ff50bc, #ff8383);
  &:active {
    background-image: linear-gradient(270deg, #ff61c2 0%, #ff8f8f 100%);
  }
  .guide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    color: #ffffff;
    font-weight: 600;

    font-size: 40px;
    letter-spacing: 4px;
    user-select: none;
  }
}
.count-cover {
  color: #fff;
  font-weight: 600;
  font-size: 71px !important;
}
.pay-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 174px;
  padding: 0 26px 0 29px;
  .remain {
    display: flex;
    flex-direction: column;
    .desc {
      color: #c9caff;
      font-weight: normal;
      font-size: 23px;
      letter-spacing: 0.44px;
      &.no-count-down {
        margin-bottom: 16px;
        color: #ffffff;
        font-size: 26px;
        letter-spacing: 0.49px;
        opacity: 0.8;
      }
    }
    .count-down {
      margin-top: 4px;
      margin-bottom: 4px;
    }
    .remain-count {
      font-weight: 600;
      font-size: 17px;
      letter-spacing: 0.32px;
      &.no-count-down {
        font-weight: 600;
        font-size: 24px;
        letter-spacing: 0.46px;
      }
    }
  }
  .btn-pay-wrapper {
    background: #fff;
    border-radius: 12px;
  }
  .btn-pay {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 297px;
    height: 116px;
    padding: 0 14px 0 16px;
    color: #fff;
    font-weight: 600;
    font-size: 50px;
    border-radius: 12px;
    user-select: none;
    &:active:not(.disabled) {
      opacity: 0.7;
    }
    &.disabled {
      opacity: 0.3;
    }
  }
}
.pay-wrapper {
  position: relative;
  z-index: 10;
}
</style>
<style lang="scss">
// ios 安全区域 fix，在父元素中包含有这个类后，就应用 padding。至于在哪里加入这个类，就由组件调用方来决定
.ios-safe-bottom {
  .ios-padding {
    height: constant(safe-area-inset-bottom);
    height: env(safe-area-inset-bottom);
    // background-image: linear-gradient(to left, #ff50bc, #ff8383);
  }
  .pay-wrapper {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
